<template>
    <ConsultNew/>
</template>
<script>
import ConsultNew from 'place/consultation/consultNew.vue'
export default {
    components:{
        ConsultNew
    }
}
</script>